var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTabBoost(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_49_1017)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9942 19.9321C19.4484 18.4779 20.3478 16.469 20.3478 14.25C20.3478 8.97806 15.9152 4.14945 13.6342 2.01371C13.1126 1.52527 12.3049 1.91031 12.2617 2.62365C11.8223 9.88369 8.62447 9.42295 7.25244 8.87792C6.87448 8.72778 6.41968 8.77119 6.158 9.08251C4.9837 10.4795 4.27637 12.2822 4.27637 14.25C4.27637 16.469 5.1758 18.4779 6.62999 19.9321C8.08417 21.3863 10.0931 22.2857 12.3121 22.2857C14.5311 22.2857 16.54 21.3863 17.9942 19.9321ZM14.7364 17.8192C15.3569 17.1779 15.7407 16.292 15.7407 15.3134C15.7407 13.5416 14.5979 11.8977 13.836 10.9987C13.5945 10.7138 13.162 10.8914 13.1319 11.2636C12.8391 14.8922 10.8922 15.115 9.82902 14.2432C9.55928 14.0221 9.09605 14.0333 9.00624 14.3703C8.92624 14.6706 8.88351 14.9868 8.88351 15.3134C8.88351 16.292 9.26727 17.1779 9.88772 17.8192C10.5082 18.4605 11.3653 18.8571 12.3121 18.8571C13.2589 18.8571 14.116 18.4605 14.7364 17.8192Z",
    fill: "url(#paint0_linear_49_1017)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_49_1017",
    x1: 4.27637,
    y1: 1.79504,
    x2: 24.1769,
    y2: 17.4036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2EC7E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E8AE6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_49_1017"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.333496)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabBoost);
export default __webpack_public_path__ + "static/media/tab_boost.62acac7f.svg";
export { ForwardRef as ReactComponent };